module.exports = " <div class=card :class=\"{ 'card--invisible': invisible, 'card--wide': wide }\" _v-d19de694=\"\"> <slot _v-d19de694=\"\"></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-d19de694!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Card.vue
// module id = 330
// module chunks = 2